/**
 * Created by Daniel on 09/04/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of as observableOf, Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import { smartEffect } from '..';
import { of } from 'rxjs';
import { CalendarEventsActionTypes, CalendarEventsReload, CalendarListRefinebyActionTypes, CalendarListRefinebyLoad } from '../actions/calendar.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { CalendarService } from '../../tamalelibs/services/calendar.service';
import { CalendarListAction } from '../../tamalelibs/components/calendar-list.config';
import { RELOAD_CALENDARS, RELOAD_CALENDARS_FAIL, RELOAD_CALENDARS_SUCCESS } from '../../tamalelibs/redux/calendar-list.actions';
import { AdvFilterHelperService } from '../../tamalelibs/services/adv-filter-helper.service';
import { ThreadService } from '../../tamalelibs/services/thread.service';
import * as _lodash from 'lodash';

@Injectable()
export class CalendarEffects {
    constructor(
        private _actions$: Actions,
        private _calendarService: CalendarService,
        private _advFilterHelper: AdvFilterHelperService,
        private _threadService: ThreadService,
    ) { }

    reloadCalendarEventsEffect$: Observable<any> = createEffect(() => this._actions$.pipe(
        ofType(CalendarEventsActionTypes.RELOAD),
        switchMap((action: CalendarEventsReload) => {
            const payload = action.payload;
            return this._calendarService.getCalendarEvents(payload).pipe(
                map(entryList => {
                    const eventThreadList = entryList['thread-list'];
                    const eventList = this._calendarService.mapToCalendarEventList(eventThreadList);

                    return smartEffect(action, {
                        type: CalendarEventsActionTypes.RELOAD_SUCCESS,
                        payload: eventList
                    });
                }),
                catchError(err => {
                    return of(smartEffect(action, {
                        type: CalendarEventsActionTypes.RELOAD_FAILED,
                        payload: err.message
                    }));
                })
            );
        })
    ));

    /**
     * to be used by event list of Ag Grid
     */
    getCalendarListEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(RELOAD_CALENDARS),
        map(action => action as CalendarListAction),
        switchMap((action: CalendarListAction) => {
            const payload = _lodash.cloneDeep(action.payload);
            if ((payload.queryInfo.categoryFilter) && (payload.queryInfo.categoryFilter.hasOwnProperty('eventType'))) {
                const noteType = _lodash.cloneDeep(payload.queryInfo.categoryFilter['eventType']);
                payload.queryInfo.categoryFilter = _lodash.omit(payload.queryInfo.categoryFilter, 'eventType');
                payload.queryInfo.categoryFilter = Object.assign(payload.queryInfo.categoryFilter, { noteType: noteType });
            }
            if ((payload.queryInfo.categoryFilter) && (payload.queryInfo.categoryFilter.hasOwnProperty('date'))) {
                const displayDate = _lodash.cloneDeep(payload.queryInfo.categoryFilter['date']);
                payload.queryInfo.categoryFilter = _lodash.omit(payload.queryInfo.categoryFilter, 'date');
                payload.queryInfo.categoryFilter = Object.assign(payload.queryInfo.categoryFilter, { displayDate: displayDate });
            }
            return this._calendarService.getCalendarEvents(payload).pipe(
                map(response => {
                    const calendarList = this._calendarService.mapCalendarListGrid(response);
                    return smartEffect(action, {
                        type: RELOAD_CALENDARS_SUCCESS,
                        payload: calendarList,
                        params: payload
                    });
                }),
                catchError(err => {
                    return observableOf({ type: RELOAD_CALENDARS_FAIL, payload: err.message });
                }));
        })
    ));

    loadCalendarListRefinebyEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CalendarListRefinebyActionTypes.LOAD),
        switchMap((action: CalendarListRefinebyLoad) => {
            const payload = action.payload;
            let categoryFilter = _lodash.cloneDeep(payload.categoryFilter);
            const advFilterArr = [];
            if (payload.advFilterMap) {
                Array.from(payload.advFilterMap.values())
                    .filter(advFilter => advFilter)
                    .forEach((advFilter: string) => advFilterArr.push(advFilter));
            }
            const advFilterStr = this._advFilterHelper.joinFiltersByAnd(advFilterArr);
            const category: Array<string> = _lodash.cloneDeep(payload.category);
            if (!(category.indexOf('date') === -1) && category.indexOf('displayDate') === -1) {
                category.push('displayDate');
            }
            if (!(category.indexOf('eventType') === -1) && category.indexOf('noteType') === -1) {
                category.push('noteType');
            }
            if (categoryFilter && (categoryFilter.hasOwnProperty('eventType'))) {
                const noteType = _lodash.cloneDeep(categoryFilter['eventType']);
                categoryFilter = _lodash.omit(categoryFilter, 'eventType');
                categoryFilter = Object.assign(categoryFilter, { noteType: noteType });
            }
            if (categoryFilter && categoryFilter.hasOwnProperty('date')) {
                const displayDate = _lodash.cloneDeep(categoryFilter['date']);
                categoryFilter = _lodash.omit(categoryFilter, 'date');
                categoryFilter = Object.assign(categoryFilter, { displayDate: displayDate });
            }
            return this._threadService.getRefinebyData(payload.entityIds, payload.searchText, category, advFilterStr, categoryFilter).pipe(
                map(response => {
                    const data: Map<string, Array<any>> = new Map();
                    category.forEach(id => {
                        if (id === 'date') {
                            data.set(id, response['displayDate']);
                        } else if (id === 'eventType') {
                            data.set(id, response['noteType']);
                        } else if (id !== 'noteType' && id !== 'displayDate') {
                            data.set(id, response[id]);
                        }
                    });
                    return smartEffect(action, {
                        type: CalendarListRefinebyActionTypes.LOAD_SUCCESS,
                        payload: data,
                    });
                }),
                catchError(err => {
                    return of(smartEffect(action, {
                        type: CalendarListRefinebyActionTypes.LOAD_FAILED,
                        payload: err.message
                    }));
                })
            );
        })
    ));

}
